<template>
	<ValidationObserver v-slot="{ failed, valid, invalid, validated, passes, validate, handleSubmit, errors }" ref="observer">
		<v-snackbar
			v-model="failed"
			color="rgb(244, 67, 54)"
			outlined
			timeout="8000"
		>
			{{ $t('validation.errors') }}
			<!--			<template v-slot:action="{ attrs }">-->
			<!--				<v-btn-->
			<!--					text-->
			<!--					v-bind="attrs"-->
			<!--					@click="failed = false"-->
			<!--				>-->
			<!--					X-->
			<!--				</v-btn>-->
			<!--			</template>-->
		</v-snackbar>
		<div class="fill-height  pa-5 pa-sm-10" v-if="AppStore.started_app" id="appreciation-page">
			<v-container class="fill-height d-flex align-center flex-row">
				<v-row class="">
					<v-card elevation="0" class="mx-auto  pa-5 pa-sm-10 mb-5" rounded="xl">
						<v-col cols="12" class="text-h2 pt-5 pb-7 text-center my-auto" id="appreciation-title"
						       v-if="AppStore.data.configuration.display_appreciation_title">
							<span v-html="AppStore.data.configuration[AppStore.locale].appreciation_title"></span>
						</v-col>

						<v-col cols="12" id="appreciation-questions"
						       v-if="questions_to_display && questions_to_display.length">
							<div v-for="(question, questionIndex) in questions_to_display"
							     :key="questions_to_display[questionIndex].id+AppStore.updatedKey" class="appreciation-question">
								<divider-view v-if="question.format === 'divider'"></divider-view>
								<slider-view v-if="question.format === 'slider' && !questions_to_display[questionIndex].must_be_hide"
								             :rules="question.is_required ? { regex: /^[1-5]+$/ } : ''"
								             v-model="questions_to_display[questionIndex]"
								             :id="'q'+questions_to_display[questionIndex].id"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></slider-view>
								<text-view v-if="question.format === 'text' && !questions_to_display[questionIndex].must_be_hide"
                           :rules="question.regex ? question.is_required ? 'required|regex:'+question.regex : 'regex:'+question.regex : question.is_required ? 'required' : ''"
								           v-model="questions_to_display[questionIndex]"
								           :id="'q'+questions_to_display[questionIndex].id"
								           :questionIndex="questionIndex" :lang="AppStore.locale"></text-view>
								<textarea-view v-if="question.format === 'textarea' && !questions_to_display[questionIndex].must_be_hide"
								               :rules="question.is_required ? 'required' : ''"
								               v-model="questions_to_display[questionIndex]"
								               :id="'q'+questions_to_display[questionIndex].id"
								               :questionIndex="questionIndex" :lang="AppStore.locale"></textarea-view>
								<select-view v-if="question.format === 'select' && !questions_to_display[questionIndex].must_be_hide"
								             :rules="question.is_required ? 'required' : ''"
								             return-object
								             :id="'q'+questions_to_display[questionIndex].id"
								             :name="questions_to_display[questionIndex].name"
								             v-model="questions_to_display[questionIndex]"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></select-view>
								<checkbox-view v-if="question.format === 'checkbox' && !questions_to_display[questionIndex].must_be_hide"
								               :rules="question.is_required ? 'required' : ''"
								               :color="AppStore.data.general.primary_color"
								               :id="'q'+questions_to_display[questionIndex].id"
								               v-model="questions_to_display[questionIndex]"
								               :questionIndex="questionIndex" :lang="AppStore.locale"></checkbox-view>
								<radio-view v-if="question.format === 'radio' && !questions_to_display[questionIndex].must_be_hide"
								            :rules="question.is_required ? 'required' : ''"
								            :color="AppStore.data.general.primary_color"
								            :id="'q'+questions_to_display[questionIndex].id"
								            v-model="questions_to_display[questionIndex]"
								            :questionIndex="questionIndex" :lang="AppStore.locale"></radio-view>
								<switch-view v-if="question.format === 'switch' && !questions_to_display[questionIndex].must_be_hide"
								             :rules="question.is_required ? 'required' : ''"
								             :color="AppStore.data.general.primary_color"
								             :id="'q'+questions_to_display[questionIndex].id"
								             v-model="questions_to_display[questionIndex]"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></switch-view>
							</div>
						</v-col>

						<v-col cols="12" class="text-center">
							<!--                        <v-btn v-if="_.isEmpty(AppStore.rating.questions_answers)"-->
							<!--                               @click="passes(submit); AppStore.rating.questions_answers = {}"-->
							<!--                               @keypress.enter="navigate" role="link" rounded-->
							<!--                               outlined elevation="0"-->
							<!--                               :large="AppStore.data.general.button_size === 'large'"-->
							<!--                               :x-large="AppStore.data.general.button_size === 'x-large'"-->
							<!--                               :x-small="AppStore.data.general.button_size === 'x-small'"-->
							<!--                               :small="AppStore.data.general.button_size === 'small'"-->
							<!--                               :color="Helpers.getColor(AppStore.data.general.primary_color.hexa)" class="revert-btn text-button"-->
							<!--                               :style="Helpers.getButtonSize(AppStore.data.general.button_size)"-->
							<!--                               v-html="AppStore.data.configuration[AppStore.locale].appreciation_retry_btn_text">-->
							<!--                        </v-btn>-->
							<v-btn @click="passes(submit)" role="link" rounded
							       elevation="0" dark
							       :large="AppStore.data.general.button_size === 'large'"
							       :x-large="AppStore.data.general.button_size === 'x-large'"
							       :x-small="AppStore.data.general.button_size === 'x-small'"
							       :small="AppStore.data.general.button_size === 'small'"
							       @keypress.enter="navigate"
							       :color="Helpers.getColor(AppStore.data.general.primary_color.hexa)"
							       class="text-button"
							       :style="Helpers.getButtonSize(AppStore.data.general.button_size)"
							       v-html="AppStore.data.configuration[AppStore.locale].appreciation_validate_btn_text">
							</v-btn>
						</v-col>
					</v-card>
				</v-row>
			</v-container>
		</div>
	</ValidationObserver>
</template>

<script>
import AppStore from "../../../stores/AppStore";
import _ from 'lodash';
import SliderView from '../../../components/communs/inputViewer3/SliderView.vue'
import TextView from '../../../components/communs/inputViewer3/TextView.vue'
import TextareaView from '../../../components/communs/inputViewer3/TextareaView.vue'
import SelectView from '../../../components/communs/inputViewer3/SelectView.vue'
import CheckboxView from '../../../components/communs/inputViewer3/CheckboxView.vue'
import RadioView from '../../../components/communs/inputViewer3/RadioView.vue'
import SwitchView from '../../../components/communs/inputViewer3/SwitchView.vue'
import DividerView from "../../../components/communs/inputViewer3/DividerView.vue";
import Helpers from "../../../services/Helpers";
import {ValidationObserver} from 'vee-validate';
import {EventBus} from "../../../services/Request";

export default {
	name: 'appreciation-view',

	components: {
		ValidationObserver,
		DividerView,
		SliderView,
		TextView,
		TextareaView,
		SelectView,
		CheckboxView,
		RadioView,
		SwitchView
	},

	props: {},

	data: () => ({
		AppStore,
		outlinedTextArea: false,
		questions: [],
		questions_to_display: []
	}),

	created() {
		EventBus.$on('updateQuestion', (data) => {
			const index = _.findIndex(this.questions_to_display, (q) => {
				return q.id === data.question.id;
			}, 0)
			if (index !== -1){
				let newQuestionToDisplay = Object.assign([], this.questions_to_display)
				newQuestionToDisplay[index] = data.question
				this.questions_to_display = newQuestionToDisplay
			}
		});
	},

	async mounted() {
		this.questions = []
		this.questions_to_display = []
		await this.getBookmarkedQuestions()
		if (AppStore.questions_by_page[2] && AppStore.questions_by_page[2].length > AppStore.data.configuration.questions_to_display_2) {
			await this.getRandomQuestions();
		} else {
			this.questions = Object.assign([], _.filter(AppStore.questions_by_page[2], (q) => {
				return !q.is_bookmarked
			}))
			this.questions_to_display = this.questions_to_display.concat(this.questions)
		}
	},

	computed: {
		Helpers() {
			return Helpers
		},
		_() {
			return _;
		}
	},

	watch: {},

	methods: {
		getBookmarkedQuestions() {
			this.questions_to_display = Object.assign([], AppStore.bookmarkedQuestions[2])
		},

		getRandomQuestions() {
			const max = AppStore.data.configuration.questions_to_display_2 - this.questions_to_display.length
			this.questions = Object.assign([], _.filter(AppStore.questions_by_page[2], (q) => {
				return !q.is_bookmarked
			}))

			for (let i = 0; i < max; i++) {
				const randomQuestionIndex = Math.floor(Math.random() * (this.questions.length));
				this.questions_to_display.push(this.questions[randomQuestionIndex]);
				this.questions.splice(randomQuestionIndex, 1)
			}
		},
		submit() {
			this.$router.push({name: 'mb-3-comment'})
		},
	}
};
</script>
<style>

</style>
